import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { CssBaseline, ThemeProvider as MuiThemeProvider, useMediaQuery } from '@mui/material';
import { lightTheme, darkTheme } from '@/design-system/theme';
import { usePreferences } from '@/store/preferences';
export function ThemeProvider({ children }) {
    const mode = usePreferences((s) => s.theme);
    const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
    const theme = useMemo(() => {
        const dark = mode === 'dark' || (mode === 'system' && prefersDark);
        return dark ? darkTheme : lightTheme;
    }, [mode, prefersDark]);
    return (_jsxs(MuiThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), children] }));
}
